import React from 'react';
import './App.scss';
import { Typography, Grid } from '@mui/joy';
const Home = () => {
  return (
    <>
    <Grid sx={{paddingTop: '10px'}}>
      <Typography level='h1' sx={{
        '@keyframes headerani': {
          '0%': {color: 'rgb(255, 72, 72)'},
          '15%': {color:'rgb(255, 246, 115)'},
          '30%': {color: 'rgb(123, 255, 145)'},
          '45%': {color: 'rgb(124, 255, 255)'},
          '60%': {color: 'rgb(132, 123, 255)'},
          '75%': {color: 'rgb(255, 115, 248)'},
          '90%': {color:'rgb(255, 72, 72)'}
        },
        animation: "headerani infinite 20s linear"
        }}>
        Welcome!
      </Typography>
    </Grid>
    <Grid>
      <Typography sx={{color: 'white'}}>This is my temporary work in progress site, soon (for sure <span role="img" aria-label='*lulz*'>😂</span>)</Typography>
      <Typography sx={{color: 'white'}}>it will be filled with some useful things.<br/> Stay tuned <span role="img" aria-label='"*wink*'>😉</span></Typography>
    </Grid>
    </>
  );
}

export default Home;